import TodayComponent from 'src/components/Today'
const Today = () => {
  return <TodayComponent />
}

export default Today
